import $i18n from '@/i18n';
import { Icon } from '@b-design/fusion';
import NameIcon from '@/components/NameIcon';
// import Space from '@/components/Space';
import { formatTime } from '@/utils';
import ColorTags from '@/components/ColorTags';
import { getSpaceStatus } from '@/utils/status';

const status = {
  active: { color: 'var(--superapp-primary-1)', cursor: 'pointer', textAlign: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' },
  disabled: { color: 'rgba(212,214,225,1)', textAlign: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' },
};
// const statusEmun = {
//   CREATED: 'Created',
//   BLOCKED: 'Freeze',
//   PENDING: 'Under Review',
//   WITHDRAW: 'Withdraw',
//   ACTIVE: 'Active',
//   REJECT: 'Rejected',
// };
const statusEmun = {
  CREATED: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.created',
    dm: '创建',
  }),
  BLOCKED: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.freeze',
    dm: '冻结',
  }),
  PENDING: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.underReview',
    dm: '审核中',
  }),
  WITHDRAW: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.withdrawn',
    dm: '已撤回',
  }),
  ACTIVE: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.active',
    dm: '激活',
  }),
  REJECT: $i18n.get({
    id: 'aopf.pages.getSpaceStatus.rejected',
    dm: '已拒绝',
  }),
};
const handleFilters = (values) => {
  const filter = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value, value: key });
  }
  return filter;
};
const statusFilters = handleFilters(statusEmun);
export const renderActionItem = ({ icon, content, active }) => {
  return (
    <div style={active ? status.active : status.disabled} >
      <Icon type={icon} size={'xs'} style={{ marginRight: '4px' }} />
      {content}
    </div>
  );
};
export const spacesColumns = [
  {
    title: $i18n.get({ id: 'aopf.pages.invitation.columnsNames', dm: '空间' }),
    // dataIndex: 'name',
    // width: 140,
    cell: (value, index, record) => (
      <div style={{ display: 'flex' }}>
        {record?.iconPublicUrl ? (
          <img
            src={record?.iconPublicUrl}
            alt=""
            style={{ width: 24, height: 24, borderRadius: '4px', marginRight: '12px', flex: '0 0 auto' }}
          />
        ) : (
          <NameIcon
            name={record?.name}
            shape="square"
            styles={{ width: 24, height: 24, borderRadius: '4px', marginRight: '12px' }}
          />
        )}

        <span>{record?.name}</span>
      </div>
    ),
  },
  {
    title: $i18n.get({ id: 'aopf.pages.invitation.columnsStatus', dm: '状态' }),
    dataIndex: 'status',
    width: 160,
    cell: (value) => <ColorTags {...getSpaceStatus(value)} />,
    // filters: statusFilters,
    // filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsCreatedOn', dm: '创建时间' }),
    dataIndex: 'gmtCreate',
    cell: (value) => formatTime(value),
    width: 160,
  },
];
